<template>
  <div class="teal fill-height">
    <v-container class="fill-height">
      <v-row align="center" justify="center">
        <v-col class="white pt-6" xl="3" lg="4" md="6" sm="8" xs="12">
          <v-text-field v-model="email" outlined label="Email" append-icon="mdi-email" hide-details class="mb-3"></v-text-field>
          <v-text-field v-model="password" outlined label="Password" append-icon="mdi-lock"></v-text-field>
          <v-row no-gutters>
            <v-col >
              <v-checkbox class="ma-0" label="Remember me" v-model="rememberMe" ></v-checkbox>
            </v-col>
            <v-col self-align="center" >
              <v-btn block color="primary" hide-details @click="login">Login</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>


    </v-container>
  </div>


</template>

<script>
  export default {
    data(){
      return {
        users: [],
        email:"ari655@goried.com",
        password: "123456",
        rememberMe: false
      }
    },
    created(){
      let token = localStorage.getItem('token')
      if(token){
        // console.log(token)
      }
    },
    methods:{
      login(){
        this.axios.post('users/login', { username: this.email, password: this.password }).then( (res) => {
          localStorage.setItem('token', res.data.token)
          this.$store.commit('mutate', { prop: 'token', data: res.data.token})
          this.$store.commit('mutate', { prop: 'user', data: res.data.user})
          this.$router.push('/')
        }).catch( (err) => {
          console.log(err)
        })
      },
    }
  }
</script>

<style scoped>
</style>